import { Button } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { useRouter } from "next/router";

import ChallengeCountdown from "@/challenges/ChallengeCountdown";
import ChallengeLearnMoreModal from "@/challenges/ChallengeLearnMoreModal/ChallengeLearnMoreModal";
import {
  container,
  contentWrapper,
  headerWrapper,
  heading,
  imageCss,
  imageWrapper,
  textWrapper,
} from "./ChallengeTeacherHomePage.style";

interface ChallengeTeacherHomePageProps {
  expirationDate?: Date | null | undefined;
}

const ChallengeTeacherHomePage = ({
  expirationDate,
}: ChallengeTeacherHomePageProps) => {
  const ButtonWithTrackEvent = withTrackEvent(Button);
  const router = useRouter();
  const now = new Date();
  const expiration = expirationDate || now;
  const month = expiration.toLocaleString("en-GB", { month: "short" });
  const date = expiration.getDate();
  const countdown = Math.floor(
    (expiration.getTime() - now.getTime()) / (1000 * 3600 * 24),
  );
  const todayMonth = now?.toLocaleString("en-GB", { month: "long" });
  return (
    <div css={container}>
      <div css={headerWrapper}>
        <h2 css={heading}>
          {todayMonth.charAt(0).toUpperCase() + todayMonth.slice(1)} reading
          challenge
        </h2>
        <ChallengeCountdown month={month} date={date} countdown={countdown} />
      </div>
      <div css={contentWrapper}>
        <div css={textWrapper}>
          <h1>Promote independent reading</h1>
          <p>
            Each month, students can read articles that interest them and earn
            tokens for every quiz, Power Words and Guided Highlighting activity
            completed. Students earn a badge when they reach their monthly
            reading goal.
            <ChallengeLearnMoreModal />
          </p>
          <ButtonWithTrackEvent
            flavor={Button.flavors.primary}
            onClick={() => router.push("/challenges")}
            objectType={objectTypes.user}
            actionName={actionNames.navigate}
            streamProperties={{
              description: "Send Teacher to Challenges",
            }}
          >
            View challenge
          </ButtonWithTrackEvent>
        </div>
        <div css={imageWrapper}>
          <img css={imageCss} alt="" />
        </div>
      </div>
    </div>
  );
};

export default ChallengeTeacherHomePage;
